import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const publicListingDetailsGuard: CanActivateFn = route => {
    const router = inject(Router);
    const id = route.paramMap.get('id');

    if (!id || !/^\d+$/.test(id)) {
        return router.createUrlTree(['/']);
    }

    return true;
};
